import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Title, Body } from '@vds-core/typography';
import { ColorTokens } from '@vds-tokens/color';
import { withVDSManager } from '@vds-core/utilities';
var propTypes = {
  /**
   * Determines the fontsize for this component.
   */
  size: PropTypes.oneOf(['bodySmall', 'bodyMedium', 'bodyLarge', 'titleSmall', 'titleMedium', 'titleLarge']),
  /**
   * Determines primitive of TitleLockupEyebrow.
   */
  primitive: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'p']),
  /**
   * Accepts a string, array or node value to render as text.
   */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),
  /**
   * Accepts a boolean to configure eyebrow font weight.
   */
  bold: PropTypes.bool,
  /**
   * @ignore
   */
  surface: PropTypes.oneOf(['light', 'dark']),
  /**
   * @ignore
   * If true, will not render paddingBottom
   */
  isStandAlone: PropTypes.bool
};
var defaultProps = {
  primitive: 'h3',
  bold: false,
  surface: 'light',
  isStandAlone: false
};
var EyebrowWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "EyebrowWrapper",
  componentId: "VDS__sc-95mfnn-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  padding-bottom: ", ";\n  text-align: inherit;\n"])), function (_ref) {
  var paddingBottom = _ref.paddingBottom;
  return paddingBottom;
});
var TitleLockupEyebrow = function TitleLockupEyebrow(props) {
  var size = props.size,
    primitive = props.primitive,
    children = props.children,
    paddingBottom = props.paddingBottom,
    bold = props.bold,
    surface = props.surface,
    viewport = props.viewport,
    isStandAlone = props.isStandAlone;
  var calculateEyebrowSize = function calculateEyebrowSize(size) {
    switch (size) {
      case 'bodySmall':
      case 'titleSmall':
        return 'small';
      case 'bodyMedium':
      case 'titleMedium':
        return 'medium';
      case 'titleLarge':
      case 'bodyLarge':
        return 'large';
      case 'titleXLarge':
        return 'XLarge';
    }
  };
  var EyebrowComponent = size && size.substring(0, 4) === 'body' ? Body : Title;
  return /*#__PURE__*/React.createElement(EyebrowWrapper, {
    paddingBottom: isStandAlone ? 0 : paddingBottom
  }, /*#__PURE__*/React.createElement(EyebrowComponent, {
    bold: bold,
    size: calculateEyebrowSize(size),
    primitive: primitive,
    children: children,
    color: surface === 'dark' ? ColorTokens.elements.primary.ondark.value : ColorTokens.elements.primary.onlight.value,
    viewport: viewport
  }));
};
export default TitleLockupEyebrow;
TitleLockupEyebrow.displayName = 'TitleLockupEyebrow';
TitleLockupEyebrow.propTypes = propTypes;
TitleLockupEyebrow.defaultProps = defaultProps;